import { render } from "./fleet.cattle.io.clustergroup.vue?vue&type=template&id=372b1547"
import script from "./fleet.cattle.io.clustergroup.vue?vue&type=script&lang=js"
export * from "./fleet.cattle.io.clustergroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__